export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 4_02.01326747.jpg";